import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationGuard } from '@app/guards/navigation.guard';
import { CanDeactivateComponent } from '@app/interfaces';
import { getHelpCentreArticle } from '@app/types/translatable.type';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ImportIntegrationService } from '../../services';
import { ImportService } from '../../services/import/import.service';
import { IntegrationStep } from '../../services/integration/import-integration.service';

export const INTEGRATIONS_HELP_LINK = getHelpCentreArticle('19432538029719');
@Component({
    templateUrl: './integrations-import.template.html',
    styleUrls: ['./integrations-import.style.scss'],
})
export class IntegrationsImportView implements CanDeactivateComponent {
    private _activeStepIndex: IntegrationStep = IntegrationStep.LIST;
    private _destroyed$: Subject<void> = new Subject<void>();

    get activeStepIndex(): number {
        return this._activeStepIndex;
    }

    constructor(
        public importService: ImportService,
        public integrationService: ImportIntegrationService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.subscribeToStepChanges();
        this.handleQueryParams();
    }

    canDeactivate(): boolean {
        if (this.shouldWarnBeforeNavigation()) {
            const isLeaving = window.confirm(NavigationGuard.warningMessage);
            if (isLeaving) {
                this.integrationService.goToStep(IntegrationStep.LIST);
            }
        }

        return true;
    }

    private shouldWarnBeforeNavigation(): boolean {
        return this._activeStepIndex !== IntegrationStep.LIST;
    }

    private subscribeToStepChanges(): void {
        this.integrationService.onStepChange.pipe(takeUntil(this._destroyed$)).subscribe((step) => {
            this._activeStepIndex = step;
        });
    }

    private handleQueryParams(): void {
        this.route.queryParams.pipe(take(1)).subscribe((queryParam) => {
            if (queryParam.error) {
                this.router.navigate([], { replaceUrl: true });
            }
            if (queryParam.id) {
                this.integrationService.previewImport(Number(queryParam.id));
                this.router.navigate([], { replaceUrl: true });
            }
        });
    }
}
